import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://bhrlwvluloieiomjdbqf.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJocmx3dmx1bG9pZWlvbWpkYnFmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcxMTQ5MzUsImV4cCI6MjA4MjY5MDkzNX0.wELV4wj5DgmSx9JfHdJPzGHdxZz5lhp652UERMAiGSw";
const supabase = createClient(supabaseUrl, supabaseKey);
export default supabase;
